import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuth: false,
    tokenpub: localStorage.getItem('tokenpub') || '',
    tokenscr: localStorage.getItem('tokenscr') || '',
    usernik: localStorage.getItem('usernik') || '',
    useremail: localStorage.getItem('useremail') || '',
    userrole: localStorage.getItem('userrole') || '',
    username: localStorage.getItem('username') || '',
    userfname: localStorage.getItem('userfname') || '',
    userlname: localStorage.getItem('userlname') || '',
    userjur: localStorage.getItem('userjur') || '',
    userbanjar: localStorage.getItem('userbanjar') || '',
    userbanjarname: localStorage.getItem('userbanjarname') || '',
    staticdata: localStorage.getItem('staticdata') || null,
  },
  mutations: {
    SET_STATICDATA(state, resp) {
      // set localStorage
      localStorage.setItem('staticdata', resp);
      // set state
      state.staticdata = resp;
    },
    AUTH_SUCCESS(state, resp) {
      const fullname = resp.firstname + ' ' + resp.lastname;
      // set localStorage
      localStorage.setItem('tokenscr', resp.token);
      localStorage.setItem('usernik', resp.nim);
      localStorage.setItem('useremail', resp.email);
      localStorage.setItem('userrole', resp.role);
      localStorage.setItem('username', fullname);
      localStorage.setItem('userfname', resp.firstname);
      localStorage.setItem('userlname', resp.lastname);
      localStorage.setItem('userjur', resp.jur);
      localStorage.setItem('userbanjar', resp.id_banjar);
      localStorage.setItem('userbanjarname', resp.banjar);
      // set state
      state.tokenscr = resp.token;
      state.usernik = resp.nim;
      state.useremail = resp.email;
      state.userrole = resp.role;
      state.username = fullname;
      state.userfname = resp.firstname;
      state.userlname = resp.lastname;
      state.userjur = resp.jur;
      state.userbanjar = resp.id_banjar;
      state.userbanjarname = resp.banjar;
      state.isAuth = true;
    },
    AUTH_LOGOUT(state) {
      // set localStorage
      localStorage.removeItem('tokenscr');
      localStorage.removeItem('usernik');
      localStorage.removeItem('useremail');
      localStorage.removeItem('userrole');
      localStorage.removeItem('username');
      localStorage.removeItem('userfname');
      localStorage.removeItem('userlname');
      localStorage.removeItem('userjur');
      localStorage.removeItem('userbanjar');
      localStorage.removeItem('userbanjarname');
      // set state
      state.tokenscr = '';
      state.usernik = '';
      state.useremail = '';
      state.userrole = '';
      state.username = '';
      state.userfname = '';
      state.userlname = '';
      state.userjur = '';
      state.userbanjar = '';
      state.userbanjarname = '';
      state.isAuth = false;
    },
  },
  actions: {
  },
  getters: {
    isAuth: (state) => state.isAuth,
    tokenpub: (state) => state.tokenpub,
    tokenscr: (state) => state.tokenscr,
    usernik: (state) => state.usernik,
    useremail: (state) => state.useremail,
    userrole: (state) => state.userrole,
    username: (state) => state.username,
    userfname: (state) => state.userfname,
    userlname: (state) => state.userlname,
    userjur: (state) => state.userjur,
    userbanjar: (state) => state.userbanjar,
    userbanjarname: (state) => state.userbanjarname,
    staticdata: (state) => state.staticdata,
  },
});
